import { describeMissingEvidenceGuidance, describeTaskEvidenceShortfall, SUB_TASK_COMPLETION_BLOCKED_CODE, SubTaskCompletionRefusal, TASK_COMPLETION_BLOCKED_CODE, TaskCompletionRefusal } from '@jms/model';

export const TASK_COMPLETION_REFUSAL_TITLE = 'This task can\'t be completed yet';

// Only the structured completion-blocked code is special; every other failure keeps its screen's normal handling.
export function readTaskCompletionRefusal(error: unknown): TaskCompletionRefusal | undefined {

  const refusal = readRefusalBody<Partial<TaskCompletionRefusal>>(error, TASK_COMPLETION_BLOCKED_CODE);
  if (!refusal) return undefined;

  return { taskName: refusal.taskName ?? '', missingEvidence: refusal.missingEvidence ?? [], openSubTasks: (refusal.openSubTasks ?? []).map(subTask => ({ ...subTask, missingEvidence: subTask.missingEvidence ?? [] })), resolvedSubTasks: refusal.resolvedSubTasks ?? [] };
}

/** The server's refusal of completing a parent with its sub-tasks, raised before anything was written. */
export function readSubTaskCompletionRefusal(error: unknown): SubTaskCompletionRefusal | undefined {

  const refusal = readRefusalBody<Partial<SubTaskCompletionRefusal>>(error, SUB_TASK_COMPLETION_BLOCKED_CODE);

  return refusal
    ? { blockedSubTasks: refusal.blockedSubTasks ?? [] }
    : undefined;
}

function readRefusalBody<T>(error: unknown, code: string): T | undefined {

  const body = error && typeof error === 'object' && 'error' in error ? (error as { error: unknown }).error : error;
  if (!body || typeof body !== 'object') return undefined;

  return (body as { code?: unknown }).code === code
    ? body as T
    : undefined;
}

// A tenant may rename or retire any status, so the text uses each sub-task's own status name and never names one itself.
export function describeTaskCompletionRefusalDetail(refusal: TaskCompletionRefusal): string {

  return [
    refusal.missingEvidence.length ? `Missing evidence: ${refusal.missingEvidence.map(describeTaskEvidenceShortfall).join(', ')}.` : '',
    refusal.openSubTasks.length ? `Open sub-tasks: ${refusal.openSubTasks.map(subTask => `${subTask.name} (${subTask.statusName})`).join(', ')}.` : '',
    refusal.openSubTasks.length ? 'Close the sub-tasks first.' : '',
    refusal.missingEvidence.length ? describeMissingEvidenceGuidance(refusal.missingEvidence) : '',
  ]
    .filter(Boolean)
    .join(' ');
}

export function taskCompletionRefusalDetail(error: unknown): string | undefined {

  const refusal = readTaskCompletionRefusal(error);
  return refusal ? describeTaskCompletionRefusalDetail(refusal) : undefined;
}
